export const isTravelReplacementAvailable = (allowance) => {
  const total = Number(allowance?.total);
  return allowance?.enabled === true && Number.isFinite(total) && total > 0;
};

export const isTravelReplacementEnabledForService = (availability, backendService) => (
  availability?.backendService === backendService && availability?.enabled === true
);
